import { Component, OnInit, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { B2cService } from '../../services/b2c.service';

@Component({
  selector: 'app-four-oh-four',
  templateUrl: './four-oh-four.component.html',
  styleUrls: ['./four-oh-four.component.scss']
})
export class FourOhFourComponent implements OnInit {

  router: Router = inject(Router);
  route: ActivatedRoute = inject(ActivatedRoute);
  b2c: B2cService = inject(B2cService);
  constructor() { }

  ngOnInit(): void {
    console.log(this.route.snapshot.queryParams);
    if (this.route.snapshot.queryParams.hasOwnProperty('id_token')) {
      this.b2c.token = this.route.snapshot.queryParams.id_token;
      this.b2c.decodeToken();
    }
    this.router.navigate(['/westminster-staging/37002']);
  }

}
